import type { DeckHtmlAttributes, DeckProperties } from "@/types";

export const propertyToHtmlAttribute = (str: keyof DeckProperties): keyof DeckHtmlAttributes => {
  return str.replace(/([A-Z])/g, "-$1").toLowerCase() as keyof DeckHtmlAttributes;
};
